import styled from 'styled-components';
import theme from 'styled-theming';

const backgroundColor = theme('name', {
  light: '#fff',
  dark: 'rgb(52, 52, 52)',
});

export const MenuContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 5px;
  border-radius: 5px;
  padding: 2px 5px;
  .overview {
    font-size: 14px;
    font-weight: 500;
    opacity: 0.8;
  }
  button {
    text-decoration: underline;
  }
  hr {
    height: 25px;
  }

  .green {
    background: #008000d1;
    color: white;
  }

  .pink {
    background: #f799aa;
    color: rgb(52, 52, 52);
  }
`;

export const FloatingMenu = styled.div`
  display: flex;
  gap: 15px;
  position: absolute;
  right: 3px;
  top: 3px;
  background-color: ${backgroundColor};
  .btn-menu {
    padding: unset;
    min-width: 40px;
    min-height: 40px;
  }
  svg {
    margin: unset !important;
  }
  hr {
    height: 17px;
    border-left: 2px solid rgba(28, 28, 28, 0.38);
  }
`;
